import React, { useContext } from 'react';
import { TextDirectionContextType, TextDirectionProviderProps } from './types';

const TextDirectionContext = React.createContext<
  TextDirectionContextType | undefined
>(undefined);

export const TextDirectionProvider: React.FC<TextDirectionProviderProps> = ({
  children,
}) => {
  const direction = document.dir ?? '';
  const textDirection = direction.toLowerCase() === 'rtl' ? 'rtl' : 'ltr';

  return (
    <TextDirectionContext.Provider value={{ textDirection }}>
      {children}
    </TextDirectionContext.Provider>
  );
};

export function useTextDirection() {
  const context = useContext(TextDirectionContext);

  if (context === undefined) {
    throw new Error(
      'useTextDirection must be used within TextDirectionProvider',
    );
  }

  return context;
}
